import { useTranslation } from 'react-i18next'
import useActiveOrDefaultChain from 'src/common/hooks/web3/useActiveOrDefaultChain'
import StatusLoader from 'src/common/ui-kit/StatusLoader/StatusLoader'

interface TxStatusViewProps {
  approveSymbol?: string
  approveStatus: 'pending' | 'loading' | 'success'
  mainStatus: 'pending' | 'loading' | 'success'
}

const TxStatusView: React.FC<TxStatusViewProps> = ({
  approveStatus,
  approveSymbol,
  mainStatus,
}) => {
  const { t } = useTranslation('trade')
  const chain = useActiveOrDefaultChain()

  return (
    <div>
      {/* <div className='text-title1 text-main-accent flex'>
        <div className='mr-2 align-top'>
          <StatusLoader status={approveStatus} />
        </div>
        {t('approve.title', { symbol: approveSymbol })}
      </div>
      <div className='text-label1 flex items-center ml-10 -mt-2 text-main'>
        <div className='mb-4'>{t('approve.description')}</div>
      </div> */}
      <div className='text-title1 text-main-accent flex'>
        <div className='mr-2 align-top'>
          <StatusLoader status={mainStatus} />
        </div>
        {t('confirm.title')}
      </div>
      <div className='text-label1 flex items-center ml-10 -mt-2 text-main'>
        {t('confirm.description', { symbol: chain.nativeCurrency?.symbol })}
      </div>
    </div>
  )
}

export default TxStatusView
